import authReducers from '../../modules/auth/store/auth.reducers';
import uiReducers from '../../ui/store/ui.reducers';

export default {
  auth: authReducers,
  ui: uiReducers
};
